//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/NXObject.js";
let d=[[[0,"Application",0,0],[0,"Description",0,0],[0,"Drname",0,0]],[[["nViolations"],"GetViolations",{R_:{violations:"Routing.DesignRuleViolation[]"}},0,0],[["shortDescription","longDescription","objects"],"CreateViolation",{R_:{violation:"Routing.DesignRuleViolation"}},3,0],[["objectToCheck"],"ClearViolationOnObject",{},1,0]],[]];
SPLM.Routing.DesignRule = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.DesignRule";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;